import EmailVerificationInstructionsPage from '../pages/emailVerificationInstructions.vue'
import EnableTwoFactor from '../pages/enable-two-factor.vue'
import Login from '../pages/login.vue'
import Verify from '../pages/verify.vue'
import VerifyEmail from '../pages/verifyEmail.vue'
import ResetPassword from '../pages/reset-password.vue'
import ResetTwoFactor from '../pages/reset-two-factor.vue'
import RequestEmailVerificationPage from '../pages/requestEmailVerification.vue'
import RequestResetPassword from '../pages/request-reset-password.vue'
import RequestTwoFactorReset from '../pages/request-two-factor-reset.vue'
import { useAuthStore } from '../stores/auth-store'
import { requireAuthentication, resetAuthStore } from './middleware'

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: [resetAuthStore],
  },
  {
    path: '/enable-two-factor',
    name: 'auth.enable-two-factor',
    component: EnableTwoFactor,
    beforeEnter: requireAuthentication,
  },
  {
    path: '/verify',
    name: 'auth.verify',
    component: Verify,
    beforeEnter: requireAuthentication,
  },
  {
    path: '/request-password-reset',
    name: 'request-password-reset',
    component: RequestResetPassword,
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: '/request-two-factor-reset',
    name: 'request-two-factor-reset',
    component: RequestTwoFactorReset,
  },
  {
    path: '/reset-two-factor',
    name: 'reset-two-factor',
    component: ResetTwoFactor,
  },
  {
    name: 'request-email-verification',
    path: '/:slug/request-email-verification',
    component: RequestEmailVerificationPage,
  },
  {
    name: 'email-verification-instructions',
    path: '/:slug/email-verification-instructions',
    component: EmailVerificationInstructionsPage,
  },
  {
    name: 'verify-email',
    path: '/verify-email',
    component: VerifyEmail,
  },
  // Unmatched paths are handled by the global catch-all in router.ts, which
  // redirects to /not-found. Don't duplicate it here — declaration order
  // would let the auth-routes catch-all win and bounce users to /login.
  { path: '/', redirect: '/login' },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter: [
      async (_to, _from, next) => {
        const authStore = useAuthStore()
        const hasValidToken = await authStore.validateToken()

        if (hasValidToken) {
          authStore.reset()
          window.location.href = `${import.meta.env.VITE_VENTURE360_SESSION_URL}/logout`
          return
        }

        authStore.reset()
        next({ name: 'login' })
      },
    ],
  },
]
